<style>

  .view-document-dialog td.fitwidth {
    display: contents;
  }

  input.full-width {
    width: 100%;
  }

  input.bold {
    font-weight: bold !important;
  }

  .view-document-dialog input[type="checkbox"],
  .view-document-dialog input[type="radio"] {
    width: 15px;
    height: 15px;
    margin-right: 10px;
    display: inline-block !important;
  }

  textarea {
    width: 100%;
  }


  .view-document-dialog .tableActionButtonRow {
    display: none;
  }

  .view-document-dialog .displayTableTemplate {
    display: none;
  }

  .view-document-dialog .display-data-field {
    display: inline;
    white-space: -moz-pre-wrap !important;
    /* Mozilla, since 1999 */
    white-space: -webkit-pre-wrap;
    /*Chrome & Safari */
    white-space: -pre-wrap;
    /* Opera 4-6 */
    white-space: -o-pre-wrap;
    /* Opera 7 */
    white-space: pre-wrap;
    /* CSS3 */
    word-wrap: break-word;
    /* Internet Explorer 5.5+ */
    white-space: normal;
  }


  .view-document-dialog .contract-data-field {
    display: none !important;
  }

  /*Styles for table in .table-div-pdf*/
  .view-document-dialog .table-div-pdf table {
    display: block;
  }

  .view-document-dialog .table-div-pdf table {
    margin: 0 auto;
    width: 100%;
    border-collapse: collapse;
    border: 1px solid black;
  }

  .view-document-dialog .table-div-pdf table thead {
    background: #bfbfbf;
  }

  .view-document-dialog .table-div-pdf table thead td {
    text-align: center;
  }

  .view-document-dialog .table-div-pdf table thead {
    background: #bfbfbf;
  }

  .view-document-dialog .table-div-pdf table tr {
    height: 16.05pt;
    padding: 0in 5.4pt 0in 5.4pt;
  }

  .view-document-dialog .table-div-pdf table td,
  .view-document-dialog .table-div-pdf table th {
    border: solid 1px black;
    margin: 0;
    padding: 5px;
    line-height: 27px;
    /* word-break: break-all; */
  }

  .view-document-dialog .table-div-pdf table td.break-all {
    word-break: break-all;
    text-align: right;
  }

  .box-tab {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .box-tab::-webkit-scrollbar {
    height: 5px;
    background-color: #f5f5f5;
  }
  .box-tab::-webkit-scrollbar-thumb {
    background-color: #a6a6a6;
  }
  .box-tab::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
  }
  .tab-reference .name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    line-height: 28px;
    font-size: 12px;
  }
  .tab {
    color: black;
    border-radius: 5px 5px 0 0;
    background-color: #f2f2f2;
    cursor: pointer;
    position: relative;
    width: 100%;
    min-width: 90px;
    .name {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: calc(100% - 30px);
      line-height: 28px;
      font-size: 12px;
    }
    a {
      span {
        line-height: 28px;
        font-size: 12px;
      }
    }
    &.active {
      background-color: #a6a6a6;
      color: white;
    }
    &.left {
      border-bottom-right-radius: 5px;
    }
    &.right {
      border-bottom-left-radius: 5px;
    }

    &.border-right::after {
      content: '';
      position: absolute;
      width: 1px;
      height: 30px;
      background: #a6a6a6;
      right: -1px;
      top: 50%;
      transform: translate(0, -50%);
    }
  }

  .box-tab {
    overflow-x: auto;
    overflow-y: hidden;
    &::-webkit-scrollbar {
      height: 5px;
      background-color: #F5F5F5;
    }
    &::-webkit-scrollbar-thumb {
      background-color: #a6a6a6;
    }
    &::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 2px rgba(0,0,0,0.3);
      background-color: #F5F5F5;
    }
  }
  /*End styles for table in .table-div-pdf*/
</style>

<h2 mat-dialog-title>
  {{ "title.document_view" | translate }}
  <button
    type="button"
    class="close"
    [mat-dialog-close]="true"
    aria-label="Close"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content #focus tabindex="-1" style="margin-top: 10px;">
  <div
    class="d-flex"
    id="box-center"
    style="width: 100%"
    *ngIf="document && document.typeId === 1"
  >
    <div style="width: 100%; position: relative; height: 52px; display: flex; align-items: center; background: #fff;">
      <div
        class="d-flex box-tab" style="width: 100%; margin-top: 0.5rem; height: 44px"
      >
        <div
          class="pl-2 py-2 tab d-flex"
          *ngFor="let file of document.mainContractAttachments; let i = index"
          [class.active]="i === activeFile"
          [class.left]="i === activeFile - 1"
          [class.right]="i === activeFile + 1"
          (click)="changeFile(i)"
          [class.border-right]="
            i !== document.mainContractAttachments.length - 1 &&
            i !== activeFile &&
            i !== activeFile - 1
          "
          [matTooltip]="file.fileName"
        >
          <div class="name">
            {{ file.fileName }}
          </div>
        </div>
        <button mat-stroked-button class="mr-2 btn-download-file-sm desktop" color="primary"
                (click)="openPDFByBrowser(data.referenceContractId)">
          <mat-icon class="mr-0">save_alt</mat-icon>
          {{ "enterprise_contract.buttons.download" | translate }}
        </button>
        <button (click)="doPrint()" mat-stroked-button class=" btn-download-file-sm desktop" color="primary" *ngIf="data.checkMan != 1">
          <mat-icon class="mr-0">print</mat-icon>
          {{ "enterprise_contract.buttons.print" | translate }}
        </button>
      </div>
    </div>
  </div>

  <ng-container *ngIf="pdfSrc !== 'notPDF'">
    <ng-container *ngIf="pdfSrc !== 'notPDF'">
      <ngx-extended-pdf-viewer class="pdf-viewer" [src]="src" useBrowserLocale="true"
                               [showDownloadButton]="false" [showRotateButton]="false" [showOpenFileButton]="false"
                               [showBookmarkButton]="false" [showPropertiesButton]="false" [showUnverifiedSignatures]="true"
                               [sidebarVisible]="true" [enablePrint]="false" [theme]="'dark'"
                               height="calc(90vh - 150px)" style="display: block; width: 100%;" [showSecondaryToolbarButton]="false"
                               [textLayer]="true" [httpHeaders]="authorization"
                               [zoom]="'page-width'">
      </ngx-extended-pdf-viewer>
    </ng-container>
  </ng-container>
  <!--      <ng-template #notUpload>-->
  <!--        <div *ngIf="src" class="doc-wrapper view-document-dialog" [innerHTML]="src | noSanitize"></div>-->
  <!--      </ng-template>-->

</mat-dialog-content>
<mat-divider></mat-divider>

